var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconToilet = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M9.03749 11.9992C8.71724 12.015 8.41124 11.823 8.29574 11.5065L5.29574 3.25645C5.15399 2.8672 5.35499 2.4367 5.74424 2.29495C6.13349 2.1532 6.56399 2.3542 6.70574 2.74345L9.52649 10.5H18.381C18.792 10.5 19.1257 10.836 19.1257 11.25C19.1257 11.664 18.792 12 18.381 12H9.07049C9.05924 12 9.04874 12 9.03749 11.9992Z", fill: "black" }),
            React.createElement("path", { d: "M12.75 18.7502H14.9985C17.0693 18.7502 18.7485 17.071 18.7485 15.0002V13.5002C18.7485 13.0862 18.4125 12.7502 17.9985 12.7502C17.5845 12.7502 17.2485 13.0862 17.2485 13.5002V15.0002C17.2485 16.243 16.2413 17.2502 14.9985 17.2502H9.75C9.336 17.2502 9 17.5862 9 18.0002C9 18.4142 9.336 18.7502 9.75 18.7502H11.25V20.2495L6.7545 20.2442L6.74925 11.2502C6.74925 10.8362 6.41325 10.5002 5.9985 10.501C5.58375 10.5017 5.2485 10.837 5.24925 11.2517L5.2545 20.9942C5.2545 21.4082 5.58975 21.7435 6.00375 21.7435L11.9985 21.751C12.4133 21.7517 12.7493 21.4157 12.7493 21.001V18.751L12.75 18.7502Z", fill: "black" }))),
        alt: 'Icon Toilet',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconToilet;
//# sourceMappingURL=index.js.map